import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { AsnViewer } from '../../../components/ASN/AsnViewer/AsnViewer'

interface ASNViewModalProps {
  viewModalState: ModalReturnType<Asn>
}

export const ASNViewModal: React.FC<ASNViewModalProps> = ({
  viewModalState
}) => {
  return (
    <Modal
      open={viewModalState.isOpen}
      maxWidth={viewModalState.size}
      title={viewModalState.title}
      onClose={viewModalState.closeModal}
    >
      {viewModalState.extendedProps && (
        <AsnViewer element={viewModalState.extendedProps} />
      )}
    </Modal>
  )
}

